import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useCssHeight } from "../lib/useCssHeight";
import { useCrew } from "../lib/crew";

// The bar above the tabs: which crew you are in, on the left, and the
// notifications bell on the right.
//
// The crew name is the switcher, the way tapping an account name switches
// accounts. It only behaves like a control when there is somewhere to switch to,
// so someone in a single crew sees their crew's name and nothing to fiddle with.
export function CrewBar({ onOpenSwitcher }: { onOpenSwitcher: () => void }) {
  const { crew, crews } = useCrew();
  const navigate = useNavigate();
  const canSwitch = crews.length > 1;
  // Measured so a screen that fits itself to the viewport (the review deck)
  // knows where the top chrome ends.
  const bar = useRef<HTMLElement>(null);
  useCssHeight(bar, "--crewbar-h");

  return (
    <header ref={bar} className="crewbar">
      <button
        className={`crewbar-name${canSwitch ? " switchable" : ""}`}
        onClick={canSwitch ? onOpenSwitcher : undefined}
        aria-haspopup={canSwitch ? "menu" : undefined}
        disabled={!canSwitch}
      >
        <span className="crewbar-title">{crew?.name ?? "Your crew"}</span>
        {canSwitch && (
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
               strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="m6 9 6 6 6-6" />
          </svg>
        )}
      </button>

      <button
        className="crewbar-bell"
        aria-label="Notification settings"
        onClick={() => navigate("/diagnostics")}
      >
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
             strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M10 5a2 2 0 1 1 4 0 7 7 0 0 1 4 6v3a4 4 0 0 0 2 3H4a4 4 0 0 0 2-3v-3a7 7 0 0 1 4-6" />
          <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
        </svg>
      </button>
    </header>
  );
}
